export const translations = {
  events: {
    eventsFromDay: {
      'en-150': 'Events from',
      'sk-SK': 'Udalosti z dňa'
    },
    eventsFromWeek: {
      'en-150': 'Events from the week',
      'sk-SK': 'Udalosti z týždňa'
    },
    eventsFromMonth: {
      'en-150': 'Events from the month of ',
      'sk-SK': 'Udalosti z mesiaca'
    },
    eventsFromCustom: {
      'en-150': 'Events from the period of',
      'sk-SK': 'Udalosti z obdobia medzi'
    },
    openAllEvents: {
      'en-150': 'Expand all events',
      'sk-SK': 'Otvoriť všetky udalosti'
    },
    xEvents: {
      'en-150': 'events',
      'sk-SK': 'udalostí',
      quantity: {
        'en-150': {
          0: 'events',
          1: 'event',
          2: 'events'
        },
        'sk-SK': {
          0: 'udalostí',
          1: 'udalosť',
          2: 'udalosti',
          5: 'udalostí'
        }
      }
    },
    searchEvents: {
      'en-150': 'Search in events',
      'sk-SK': 'Prehľadávať udalosti'
    },
    loading: {
      'en-150': 'Loading',
      'sk-SK': 'Načítavam'
    },
    activeFilter: {
      'en-150': 'filters applied',
      'sk-SK': 'filtre aktívne',
      quantity: {
        'en-150': {
          0: 'filters applied',
          1: 'filter applied',
          2: 'filters applied'
        },
        'sk-SK': {
          0: 'filtrov aktívnych',
          1: 'filter aktívny',
          2: 'filtre aktívne',
          5: 'filtrov aktívnych'
        }
      }
    },
    activeFiltersMessage: {
      'en-150': 'You have applied',
      'sk-SK': 'Máte'
    },
    addedToday: {
      'en-150': 'Added today',
      'sk-SK': 'Dnes pridané'
    },
    deletedToday: {
      'en-150': 'Event cancelled',
      'sk-SK': 'Udalosť zrušená'
    },
    showEditors: {
      'en-150': 'Show editors',
      'sk-SK': 'Zobraziť redaktorov'
    },
    exportingMode: {
      'en-150': 'Exporting',
      'sk-SK': 'Exportovať'
    },
    exportAllEvents: {
      'en-150': 'Export all',
      'sk-SK': 'Exportovať všetko'
    },
    editMode: {
      'en-150': 'Editor Mode',
      'sk-SK': 'Editovať'
    },
    addEventLabel: {
      'en-150': 'Create event',
      'sk-SK': 'Vytvoriť udalosť'
    },
    modalSoftLabel: {
      'en-150': 'Are you sure you want to cancel this event',
      'sk-SK': 'Chcete naozaj zrušiť túto udalosť'
    },
    modalHardLabel: {
      'en-150': 'Are you sure you want to delete this event',
      'sk-SK': 'Chcete naozaj zmazať túto udalosť'
    },
    modalHardDeleteLabel: {
      'en-150': 'Delete event',
      'sk-SK': 'Zmazať udalosť'
    },
    modalSoftDeleteLabel: {
      'en-150': 'Cancel event',
      'sk-SK': 'Zrušiť udalosť'
    },
    modalCancelLabel: {
      'en-150': 'Cancel',
      'sk-SK': 'Ponechať'
    }
  }
}
